import type { ThreadEntry } from "../../api/threads/liveMessages";
import { reviewedMemoryOf } from "../threads/entries/humanStepResponse";

/**
 * The memory whose review step waits in this Thread now, as the server finds it before it
 * decides a memory from outside (`memory_threads.py`, `_waiting_review`): the open human step
 * of a Thread not closed, if it reviews a memory. While it waits, that step is the one place
 * to word, confirm or discard the memory (OW-07); `null` otherwise.
 */
export function memoryUnderReview(entries: readonly ThreadEntry[], openHumanStepEntry: number | null, closed: boolean): string | null {
  if (closed || openHumanStepEntry === null) return null;
  const request = entries.find((entry) => entry.number === openHumanStepEntry);
  return request?.payload.kind === "human_step_requested" ? reviewedMemoryOf(request.payload) : null;
}
